import { Heading } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export function AssignPeopleAndGroupsHeader(): JSX.Element {
  return <Heading variant="h3">2. Assign people and groups</Heading>;
}
